export default __webpack_public_path__ + "static/media/section7 mobile.4ad0e2aa.png";